import React, { useState } from "react";
import Image from "next/image";
import { useTranslation } from 'react-i18next';
import styles from "./BookDemoPopup.module.css";
import calendarIcon from "../../src/assets/icons/Calendar.svg";// Update path as needed

const BookDemoPopup = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState("existing");
  // Calendly links for different user types
  const calendlyLinks = {
    existing:
      "https://calendly.com/d/cn22-7m5-7b3/map-your-plan-15min-finance-session",
    new: "https://calendly.com/d/cn2x-32k-vcx/map-your-plan-book-a-45-min-finance-session-matt",
  };
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContainer}>
        <button className={styles.closeButton} onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className={styles.popupContent}>
          <div className={styles.iconContainer}>
            <Image
              src={calendarIcon}
              alt={t("Calendar icon")}
              width={24}
              height={24}
            />
          </div>

          <h3 className={styles.meetingTitle}>{t("Book a Meeting with us")}</h3>
          <p className={styles.meetingSubtitle}>
            {t("Flexible pricing that grows with you.")}
          </p>

          <div className={styles.optionsContainer}>
            <div
              className={`${styles.optionCard} ${
                selectedOption === "existing" ? styles.selected : ""
              }`}
              onClick={() => setSelectedOption("existing")}
            >
              <div className={styles.optionHeader}>
                <div className={styles.optionIcon}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="2"
                      y="4"
                      width="20"
                      height="16"
                      rx="2"
                      stroke="#0A2647"
                      strokeWidth="2"
                    />
                    <path d="M8 12H16" stroke="#0A2647" strokeWidth="2" />
                    <path d="M8 8H16" stroke="#0A2647" strokeWidth="2" />
                    <path d="M8 16H12" stroke="#0A2647" strokeWidth="2" />
                  </svg>
                </div>
                <div className={styles.optionInfo}>
                  <h4>{t("Existing User")}</h4>
                  <span className={styles.duration}>{t("15 mins Call")}</span>
                </div>
              </div>
              <p className={styles.optionDescription}>
                {t(
                  "Quick check-in, resolve issues, discuss updates, ensure smooth experience."
                )}
              </p>
              <div className={styles.radioButton}>
                {selectedOption === "existing" && (
                  <div className={styles.radioInner}></div>
                )}
              </div>
            </div>

            <div
              className={`${styles.optionCard} ${
                selectedOption === "new" ? styles.selected : ""
              }`}
              onClick={() => setSelectedOption("new")}
            >
              <div className={styles.optionHeader}>
                <div className={styles.optionIcon}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="2"
                      y="4"
                      width="20"
                      height="16"
                      rx="2"
                      stroke="#0A2647"
                      strokeWidth="2"
                    />
                    <path d="M8 12H16" stroke="#0A2647" strokeWidth="2" />
                    <path d="M8 8H16" stroke="#0A2647" strokeWidth="2" />
                    <path d="M8 16H12" stroke="#0A2647" strokeWidth="2" />
                  </svg>
                </div>
                <div className={styles.optionInfo}>
                  <h4>{t("New User")}</h4>
                  <span className={styles.duration}>{t("45 mins call")}</span>
                </div>
              </div>
              <p className={styles.optionDescription}>
                {t("Explain features, demo walkthrough, explain requirements.")}
              </p>
              <div className={styles.radioButton}>
                {selectedOption === "new" && (
                  <div className={styles.radioInner}></div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.popupFooter}>
          <button className={styles.cancelButton} onClick={onClose}>
            {t("Cancel")}
          </button>
          <button
            className={styles.confirmButton}
            onClick={() => {
              onConfirm(selectedOption, calendlyLinks[selectedOption]);
              window.location.href = calendlyLinks[selectedOption];
            }}
          >
            {t("Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookDemoPopup;
